import { Component, DOCUMENT, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { TopbarComponent } from './layout/topbar/topbar.component';
import { NotificationsComponent } from './shared/notifications/notifications.component';
import { hasText } from './core/strings';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, TopbarComponent, NotificationsComponent],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class AppComponent {
  constructor() {
    const tr  = inject(TranslateService);
    const doc = inject(DOCUMENT);
    tr.addLangs(['da', 'en']);
    tr.setDefaultLang('da');

    // Keep <html lang> in step with the active language — screen readers use it to pick
    // pronunciation, and browsers use it to decide whether to offer a page translation.
    // Subscribed before use() so the initial language is caught as well; the topbar switcher
    // goes through the same event, so it needs no code of its own.
    tr.onLangChange.subscribe(({ lang }) => doc.documentElement.lang = lang);

    const saved = localStorage.getItem('vf_lang');
    tr.use(hasText(saved) && tr.getLangs().includes(saved) ? saved : 'da');
  }
}
